import type { OpcionesErrorAumentado } from '@comun/errorAumentado'

export type DatosDeReporte = {
  message: string
  opciones?: OpcionesErrorAumentado
  /** Ruta actual del cliente al momento del error */
  rutaActual?: string
  /** Estado/contexto de la app al momento del error (ej: modal abierto) */
  estadoApp?: string
}

/**
 * Composable para reportar errores al sistema de monitoreo
 */
export const useReportero = () => {
  const reportarErrorAumentado = async (datos: DatosDeReporte) => {
    const fx = 'reportarErrorAumentado'
    const { message, opciones, rutaActual, estadoApp } = datos
    // Log local
    consolo.error(fx, { message, opciones, rutaActual, estadoApp })

    try {
      const headers = await HeadersConAuth()

      await comoSiFueraPorAxios({
        url: `${contextoApp.buildConfig.apiUrl}/reporte-error`,
        method: 'POST',
        headers,
        data: { message, opciones, rutaActual, estadoApp }
      }, { reportarError: false })
    } catch (err) {
      consolo.error(fx + ' falló también', err)
    }
  }
  return {
    reportarErrorAumentado
  }
}

// Export directo para uso sin destructuring
export const Reportero = {
  ReportarErrorAumentado: async (datos: DatosDeReporte) => {
    const { reportarErrorAumentado } = useReportero()
    return reportarErrorAumentado(datos)
  }
}
